<template>
  <ComboPicker
    :label="label"
    strings="ocorrência;a"
    icon="mdi-tune"
    :orientation="orientation"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="
      orientation == 'horizontal' ? 'Todas as ocorrências' : '(Todas)'
    "
    types="grouped-items"
    :tags="[]"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'
import { OrgApi } from '@/models'
import { orderBy } from 'oderon-commons/src/utils'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Ocorrência' },
    orientation: { type: String, default: 'vertical' },
    value: {},
    orgId: { type: Number, required: true }
  },
  watch: {
    // se a org mudar, zera a seleção, pois o valor anterior
    // não faz sentido para outra org.
    orgId() {
      this.fetchData()
      this.$emit('input', null)
    }
  },
  data() {
    return {
      allItems: []
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      let fetcher = new OrgApi(this.orgId)
      let configs = await fetcher.get('occurrences/configs')
      configs = configs.map((x) => {
        let group = x.type == 'info' ? 'Informativas' : 'Infrações'
        return { id: x.id, name: x.name, group }
      })
      this.allItems = orderBy(configs, [['name', 'asc']])
    }
  }
}
</script>

<style></style>
